<script lang="ts">
    import type { OrganizationData, OrganizationUserRoleData } from "@anyways-open/identity-api-client";
    import type { OrganizationInviteData } from "@anyways-open/identity-api-client/dist/data/OrganizationInviteData";
    import { appManager } from "../../AppManagerStore";
    import UserInviteRow from "./UserInviteRow.svelte";
    import UserRoleRow from "./UserRoleRow.svelte";

    let roles: OrganizationUserRoleData[] = [];
    let invites: OrganizationInviteData[] = [];

    export let data: OrganizationData;

    $: if (typeof data !== "undefined") {
        roles = data.users;
        invites = data.invites;

        invites = invites.filter(x => !x.accepted);
    }

    const newInvite = async () => {
        const result = await $appManager.ModalHooks.InviteUserModal.open(data.id);

        if (typeof result !== "undefined") {
            invites.push(result);

            invites = invites;
        }
    };
</script>

<div class="card-header">
    <div class="row align-items-center">
        <div class="col">
            <h4 class="mb-0">Users</h4>
        </div>
        <div class="col-auto">
            <button class="btn btn-xs btn-primary"
            on:click={async () => await newInvite()}>Invite user</button>
        </div>
    </div>
</div>
<div class="card-body">
    <div class="list-group list-group-flush">
        {#if roles.length == 0 && invites.length == 0}
            This organization doesn't have any users.
        {/if}
        {#each roles as role}
            <UserRoleRow organization={data} data={role} />
        {/each}
        {#each invites as invite}
            <UserInviteRow data={invite} />
        {/each}
    </div>
</div>
